import gql from 'graphql-tag';

export const updateLocationMutation = gql`
	mutation UpdateLocation($input: LocationInput) {
		updateLocation(input: $input) {
			id
			name
			slug
			type
			address
			city
			state
			zip
			country
			lat
			lon
			phone
			email
			website
			operatingHours
			isPublic
			isPrivate
			owner {
				id
				name
				slug
				username
				email
			}
			leagues {
				id
				name
				slug
				type
			}
			teams {
				id
				name
				slug
				divisions {
					id
					name
				}
			}
			tournaments {
				id
				name
				slug
			}
			createdAt
		}
	}
`;
